import {create} from "zustand";
import {AddressInterface} from "@/lib/type/address.type";
import {requestAddress} from "@/lib/api/address";

type AddressStore = {
    addressList: AddressInterface[];
    setAddressList: (list: AddressInterface[]) => void;
    deleteAddress: (id: string) => void;
    getAddressList: () => Promise<void>;
}

export const useAddressStore = create<AddressStore>(
    (set, get) => ({
        addressList: [],
        setAddressList(list: AddressInterface[]) {
            set({addressList: list});
        },
        deleteAddress(id: string) {
            const list = get().addressList;
            const newList = list.filter((item) => item.id !== id);
            set({addressList: newList});
        },
        async getAddressList() {
            const res = await requestAddress();
            if (res.code === 200) {
                get().setAddressList(res.data);
            }
        }
    })
);

